import { useState } from "react";
import { motion } from "motion/react";
import { ChevronDown } from "lucide-react";

export const FaqItem: React.FC<{ question: string; answer: string }> = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="py-6">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-left cursor-pointer group">
        <h3 className="text-lg md:text-xl font-medium pr-8 group-hover:text-landing-accent transition-colors">{question}</h3>
        <ChevronDown className={`w-5 h-5 text-black/40 shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
      {/* Answer always in DOM for SEO crawlability — visually collapsed via height animation */}
      <motion.div
        initial={false}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="overflow-hidden"
      >
        <p className="pt-4 text-black/60 leading-relaxed max-w-3xl">{answer}</p>
      </motion.div>
    </div>
  );
};
